import { type RemixI18NextOption } from 'remix-i18next/server';
import { serverOnly$ } from 'vite-env-only/macros';

export const languages = {
    de: 'DE',
    en: 'EN'
};

export function buildConfig(translations: { [L in keyof typeof languages]: any }, defaultLang: keyof typeof languages) {
    return {
        supportedLngs: Object.keys(languages),
        fallbackLng: defaultLang,
        defaultNS: 'common',
        resources: serverOnly$(translations)
    } satisfies RemixI18NextOption['i18next'];
}
